import React from 'react';
import './FakeServer.css';

const FakeServer = () => (
    <div className="fake-server">
        <div className="fake-server-icon">
            <div className="bip small" />
        </div>
        <div className="fake-server-name">
            <div className="bip" />
        </div>
        <div className="fake-server-button">
            <div className="bip" />
        </div>
    </div>
);

export default FakeServer;
